import React from 'react';
import { ConnectedPaxField } from '../FlightsManager/MobileFields/PaxField';

export const PaxSelectorMobile = ({ isHotelOptionEnabled }) => {
    return (
        <React.Fragment>
            <ConnectedPaxField isHotelOptionEnabled={isHotelOptionEnabled} />
        </React.Fragment>
    );
};
